import { Settings, Info } from "lucide-react";

export default function OpsSettings() {
  return (
    <div className="space-y-4" data-testid="ops-settings">
      <div className="bg-white border border-slate-200 rounded-2xl p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-hocp-navy text-white flex items-center justify-center shrink-0">
            <Settings className="w-4 h-4"/>
          </div>
          <div className="flex-1">
            <h3 className="font-display text-[16px] font-semibold text-hocp-navy">Operations Hub Settings</h3>
            <p className="text-[13px] text-slate-500 mt-1">
              Per-user settings live in <a href="/operations-hub/subscriptions" className="text-hocp-navy underline">Subscriptions</a>.
              Advanced moderator settings (channel throttling, retention windows, per-audience defaults) come in Phase B.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-sky-50/50 border border-sky-200 rounded-2xl p-4 flex items-start gap-3">
        <Info className="w-4 h-4 text-sky-600 mt-0.5 shrink-0"/>
        <div className="text-[12.5px] text-sky-900">
          <div className="font-semibold">Integration recipe for module developers</div>
          <div className="mt-1">
            Any module can push into the Ops Hub via <span className="mono bg-white px-1.5 py-0.5 rounded">POST /api/ops/v1/publish</span> or by importing <span className="mono bg-white px-1.5 py-0.5 rounded">from engines.opshub import publish_event</span>.
            Fields: <span className="mono">module, kind, title, priority, audience, entity_kind, entity_id, entity_ref</span>. Subscribers get a fanout notification automatically.
          </div>
        </div>
      </div>
    </div>
  );
}
